// extracted by mini-css-extract-plugin
module.exports = {"container":"Spinner_container__96-Ic","notVisible":"Spinner_notVisible__SE3fr","spinner":"Spinner_spinner__1tZQn"};